import { Component, ViewChild, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpService } from '../../services/http.service';
import { AuthenService } from '../../services/authen.service';
import { HelperService } from '../../services/helper.service';
@Component({
    selector: '',
    templateUrl: './group-hs-member-detail.html',
})
export class GroupHSMemberDetailComponent implements OnInit {
    subs: any = null;
    id: number = 0;
    item: any = null;

    nameValueFields: Object = { text: 'Name', value: 'Id' };
    groupParentSource: Array<any> = [];

    constructor(private http: HttpService, private auth: AuthenService, private route: ActivatedRoute, private helper: HelperService, private router: Router) {
        this.subs = route.params.subscribe(params => {
            this.id = params['id'];
        })
    }

    ngOnDestroy() {
        this.subs.unsubscribe();
    }

    ngOnInit() {

        this.getParentGroupDDL(0);
    }

    load(id: number) {
        this.http.get(`api/HSGroupMember/GetById/${id}`, res => {
            this.item = res.Result;
            
        });
    }

    isInputValid() {
        let msg = null;
        if (this.item.Code == null) {
            msg = 'Customer code is required'
        }
        

        return msg;
    }

    onSave() {
        let err = this.isInputValid();
        if (err == null) {
            this.http.save('api/HSGroupMember/SaveGroupMember', this.item, res => {
                this.load(res.LongID);
                this.router.navigate(['/group-hs-member-detail', res.LongID]);
            });
        } else {
            this.helper.alertFailed(err);
        }
    }




    getParentGroupDDL(parentId:number) {
        this.http.get('api/HSGroupMember/GetListGroupHSByParent/'+parentId, res => {
            debugger;
            this.groupParentSource = res.Result;
            let noparentOpt = {"Name":"","Id":0};
            this.groupParentSource.push(noparentOpt);

            let idGet = (this.id == undefined || this.id == null) ? 0 : this.id;

            this.load(this.id);



        }, null);
    }

    


}
